import React, {Fragment, useEffect} from "react";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "semantic-ui-react";
import DimmerLoader from "../../../components/DimmerLoader/DimmerLoader";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import { getRoles } from "./RolesList.slice";
import { IRole } from "./RolesList.types";
//ToDo ����� ��� ����� ������-�� ������� �� �����
//import '../Users/styles.scss';


const RolesList = () => {
    const dispatch = useAppDispatch();
    const { roles, rolesLoader } = useAppSelector(state => state.RolesList);

    useEffect(() => {
        dispatch(getRoles())
    }, [dispatch]);

    return (
        <div className="cms-container-general">
            {roles.length > 1 &&
                <Table celled textAlign="center">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Role name</TableHeaderCell>
                            <TableHeaderCell>Role description</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {roles?.map((role: IRole) => {
                            return (
                                <TableRow key={role.id}>
                                    <TableCell>{role.name}</TableCell>
                                    <TableCell>{role.description}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            }
            {rolesLoader &&
                <DimmerLoader />
            }
        </div>
    );
}

export default RolesList;
